import React from 'react';
import { X } from 'lucide-react';

export default function GifPicker({ onSelect, onClose }) {
  const [q, setQ] = React.useState('');
  const [results, setResults] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const key = process.env.REACT_APP_GIPHY_API_KEY;

  React.useEffect(() => {
    if (!key) return;
    const term = q.trim();
    const url = term
      ? `https://api.giphy.com/v1/gifs/search?api_key=${key}&q=${encodeURIComponent(term)}&limit=24&rating=g`
      : `https://api.giphy.com/v1/gifs/trending?api_key=${key}&limit=24&rating=g`;
    setLoading(true);
    const timer = setTimeout(() => {
      fetch(url).then(r => r.json()).then(data => setResults(data.data || [])).catch(() => setResults([])).finally(() => setLoading(false));
    }, term ? 350 : 0);
    return () => clearTimeout(timer);
  }, [q, key]);

  const pick = (g) => {
    const media = g.images?.fixed_height?.url || g.images?.original?.url;
    const preview = g.images?.fixed_width?.url || media;
    if (!media) return;
    onSelect({ id: g.id, media_url: media, preview_url: preview, title: g.title || '' });
  };

  if (!key) return null;

  return (
    <div className="feed-gif-modal" data-testid="feed-gif-modal" onClick={onClose}>
      <div className="feed-gif-modal-inner" onClick={(e) => e.stopPropagation()}>
        <div className="feed-gif-modal-head">
          <input autoFocus placeholder="Search GIFs…" value={q} onChange={(e) => setQ(e.target.value)} maxLength={50} data-testid="feed-gif-search-input" />
          <button type="button" onClick={onClose} data-testid="feed-gif-modal-close"><X size={16} /></button>
        </div>
        {loading && <div className="feed-gif-loading">Searching…</div>}
        <div className="feed-gif-grid" data-testid="feed-gif-grid">
          {results.map(g => (
            <button type="button" key={g.id} className="feed-gif-thumb" onClick={() => pick(g)} data-testid={`feed-gif-opt-${g.id}`}>
              <img src={g.images?.fixed_height_small?.url || g.images?.fixed_width?.url} alt={g.title} loading="lazy" />
            </button>
          ))}
        </div>
        <div className="feed-gif-attrib">Powered by GIPHY</div>
      </div>
    </div>
  );
}
